import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ItemService } from '@services/item.service';
import { getItemUuid } from '../item-details/item-details.component';

@Component({
  selector: 'app-create-new-item',
  templateUrl: './create-new-item.component.html',
  styleUrls: ['./create-new-item.component.scss']
})
export class CreateNewItemComponent implements OnInit {
  itemBasicDetails: any;
  itemuuid: any;
  @Input() selectLevels: any;
  addItem: any;
  itemId: any;
  action = '';
  selectedTabIndex = 0;
  testId: any;


  constructor(private itemService: ItemService, private router: Router, private routerstate: ActivatedRoute,
    public dialogRef: MatDialogRef<CreateNewItemComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: getItemUuid) {
    this.testId = this.router.getCurrentNavigation()?.extras?.state?.testId;
  }

  ngOnInit(): void {
    this.itemBasicDetails = this.data?.itemBasicDetails;
    this.itemuuid = this.data?.itemuuid;
    if (this.data?.itemuuid == null) {
      this.action = 'createItem';
    } else {
      this.action = 'editItem';
    }
  }
}
